export class ValidatorFormsInformation {
  static validateText(
    value: string,
    fieldName: string,
    maxLength: number,
  ): string | null {
    const allowedPattern = /^[a-zA-ZáéíóúÁÉÍÓÚäëïöüÄËÏÖÜàèìòùÀÈÌÒÙñÑ,.\s]+$/;
    const text = value.trim();
    const fieldNameFormatted =
      fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
    if (!text) {
      return `${fieldNameFormatted} es requerido`;
    }
    if (text.length > maxLength) {
      return `Se permite máximo ${maxLength} caracteres como ${fieldName.toLowerCase()}`;
    }
    if (!allowedPattern.test(text)) {
      return `${fieldNameFormatted} contiene caracteres inválidos`;
    }
    return null;
  }
  static validateNumber(
    value: number | null,
    fieldName: string,
    maxLength: number,
  ): string | null {
    if (!value) {
      return `Se requiere mínimo un dígito como ${fieldName.toLowerCase()}`;
    }

    if (value.toString().length > maxLength) {
      return `Se permite máximo ${maxLength} dígitos como ${fieldName.toLowerCase()}`;
    }
    return null;
  }
}
